import ApiService from '../../../services/ApiService'

export default {
  name: 'Indication',

  data: () => ({
    loading: false,
    loadingList: false,
    loadingNotification: false,
    copied: false,
    referralLink: null,
    referralToken: null,
    notificationEmail: null,
    referrals: [],
    apiService: new ApiService(),
    form: {
      creatorName: null,
      creatorCompany: null,
      creatorEmail: null,
    },
    steps: [
      {
        number: 1,
        icon: 'mdi-link-variant',
        title: 'Gere seu link',
        description: 'Preencha seus dados e gere seu link exclusivo de indicação.',
      },
      {
        number: 2,
        icon: 'mdi-share-variant-outline',
        title: 'Compartilhe',
        description: 'Envie o link para hospitais, clínicas ou empresas que se beneficiariam do FixSystem.',
      },
      {
        number: 3,
        icon: 'mdi-account-check-outline',
        title: 'Validação',
        description: 'O indicado preenche os dados e nossa equipe valida e agenda uma apresentação.',
      },
      {
        number: 4,
        icon: 'mdi-gift-outline',
        title: 'Você é recompensado',
        description: 'Após o primeiro pagamento do indicado, a sua recompensa é liberada.',
      },
    ],
    whoCanRefer: [
      {
        icon: 'mdi-hospital-building',
        text: 'Estabelecimentos assistenciais de saúde (clínicas ou hospitais) com equipes de engenharia clínica ou infraestrutura próprias',
      },
      {
        icon: 'mdi-briefcase-outline',
        text: 'Empresas prestadoras de serviço de engenharia clínica, assistência técnica e facilities em geral',
      },
    ],
    institution: {},
    user: {},
  }),

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.form.creatorName = this.user?.name || null
    this.form.creatorEmail = this.user?.email || null
    this.form.creatorCompany = this.institution?.name || null
    this.loadReferrals()
  },

  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    async generateLink() {
      if (!this.$refs.generateForm.validate()) return

      this.loading = true

      await this.apiService
        .post('ReferralLink/generate', this.form)
        .then((response) => {
          const token = response.content?.token || response.content
          this.referralToken = token
          this.notificationEmail = response.content?.notificationEmail || null
          this.referralLink = `${window.location.origin}/referral/${token}`
          this.loadReferrals()
        })
        .catch((err) => {
          this.$toast.error(err?.body?.message || 'Erro ao gerar link de indicação.')
        })
        .finally(() => {
          this.loading = false
        })
    },

    async updateNotificationEmail() {
      if (!this.referralToken) return

      this.loadingNotification = true

      await this.apiService
        .patch(`ReferralLink/${this.referralToken}/notification-email`, {
          notificationEmail: this.notificationEmail || null,
        })
        .then(() => {
          this.$toast.success('E-mail de notificação salvo!')
        })
        .catch((err) => {
          this.$toast.error(err?.body?.message || 'Erro ao salvar e-mail de notificação.')
        })
        .finally(() => {
          this.loadingNotification = false
        })
    },

    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.referralLink)
        this.copied = true
        setTimeout(() => { this.copied = false }, 2000)
      } catch {
        this.$toast.error('Não foi possível copiar o link.')
      }
    },

    async loadReferrals() {
      this.loadingList = true

      await this.apiService
        .post('ReferralLink/list/me', {
          page: 1,
          pageSize: 100,
        })
        .then((response) => {
          this.referrals = response.content?.referrals || []
        })
        .catch(() => {
          this.referrals = []
        })
        .finally(() => {
          this.loadingList = false
        })
    },

    statusInfo(value) {
      const statuses = [
        { value: 0, label: 'Indicado', color: '#9E9E9E' },
        { value: 1, label: 'Em Negociação', color: '#FF9800' },
        { value: 2, label: 'Contratado', color: '#4CAF50' },
        { value: 3, label: 'Não Contratado', color: '#F44336' },
        { value: 4, label: 'Pago', color: '#2196F3' },
      ]
      return statuses.find((s) => s.value === value) || { label: 'Desconhecido', color: '#9E9E9E' }
    },

    formatDate(date) {
      if (!date) return '—'
      return new Date(date).toLocaleDateString('pt-BR')
    },
  },
}
